// extracted by mini-css-extract-plugin
export default {"footerHeadContainer":"FooterHead_footerHeadContainer__gt49V","button3":"FooterHead_button3__LpML+","affilatebutton":"FooterHead_affilatebutton__v5b9v"};